import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';
import { MicrosoftAuthService } from '../../services/microsoft-auth.service';
import { Observable } from 'rxjs';
import { SesionUsuario } from '../../interfaces/SesionUsuario.interface';
import { loadLogin } from '../../state/actions/login.actions';
import { selectorLoading } from '../../state/selectors/login.selector';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent implements OnInit {
  loading: Observable<boolean> = new Observable();
  sesion$: Observable<SesionUsuario> | undefined;

  constructor(
    private microsoftAuthService: MicrosoftAuthService,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.microsoftAuthService.handleRedirectPromise();
    this.loading = this.store.select(selectorLoading);
    this.store.dispatch(loadLogin());
  }

  login(): void {
    this.microsoftAuthService.login();
  }
}


